// extracted by css-extract-rspack-plugin
export default {"card":"CardRow_card__kRN1B","closeButton":"CardRow_closeButton__Uwd0Q"};